import { IVendorInvoiceDto } from '../../dtos/documents/VendorInvoices/IVendorInvoiceDto';
import { AppEntities } from "../../config/entities";
import { DocumentService } from "./DocumentService";
import {ReturnOfGoodsFromVendorsDto} from "../../dtos/documents/ReturnOfGoodsFromVendors/ReturnOfGoodsFromVendorsDto";

export class ReturnOfGoodsFromVendorsService extends DocumentService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
    async createBasedAtVendorInvoice(id:string){
        const sourceDocumentDto = await AppEntities.VendorInvoices.getDataService().Get(id);
        const targetDocumentDto:ReturnOfGoodsFromVendorsDto = {...sourceDocumentDto};
        return targetDocumentDto;
    };
}